<template>
  <div>
    <div v-if="!is_sent_file">
      <div>
        <p><b>File</b></p>
        <div class="flex flex_align_center">
          <input class="padding_0" style="border-radius: 0;" type="file" accept=".pdf, .doc, .docx" @change="getFile">
          <div class="horizontal_space"></div>
          <p class="bold" v-if="file">{{file.name}}</p>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div>
        <p><b>File Name</b></p>
        <input v-model="file_name" type="text" class="full_width" placeholder="שם הקובץ">
      </div>
      <div class="vertical_space"></div>
      <div v-if="!file_helper.isAuthorized(file_name)">
        <p class="margin_0"><b>אנא תקנ/י את השגיאות הבאות בשם של הקובץ:</b></p>
        <p class="margin_0" v-for="file_error in file_errors" :key="file_error">תו לא מקובל - "<b>{{ file_error }}</b>"</p>
      </div>
      <p v-if="file != undefined && !isFileSizeOver5KB"><b>שגיאה: הגודל של הקובץ נמוך מ- 5KB</b></p>
      <div class="vertical_space"></div>
      <div class="vertical_space"></div>
      <div class="modal_footer">
        <a
          @click="submit()"
          :class="{ 'is-loading': is_loading, faded: !isAuthorized || !isFileSizeOver5KB }"
          class="button is-info"
          >Submit</a
        >
      </div>
    </div>
    <p v-else class="bold">הקובץ הועלה בהצלחה.</p>
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex'
import FileHelper from '@/classes/file_helper.js'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'upload-file-form',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      is_sent_file: false,
      file_helper: new FileHelper(),
      file: undefined,
      file_name: '',
      file_errors: []
    }
  },
  watch: {
    file_name () {
      this.file_errors = this.file_helper.getErrors(this.file_name)
    }
  },
  computed: {
    isAuthorized () {
      if (this.file == undefined) {
        return false
      }
      return this.file_helper.isAuthorized(this.file_name)
    },
    isFileSizeOver5KB () {
      if (this.file == undefined) {
        return false
      }
      let file_size_kb = this.file.size / 1000
      return file_size_kb > 5
    }
  },
  methods: {
    getFile (event) {
      let file = event.target.files[0]
      this.file = file
      this.file_name = file.name
    },
    submit () {
      let form_data = new FormData()
      form_data.append('file', this.file)
      form_data.append('file_name', this.file_name)
      form_data.append('resource_type', this.payload.resource_type)
      form_data.append('resource_id', this.payload.resource_id)
      this.is_loading = true
      this.$network_utils.uploadFile(form_data).then(() => {
        if (this.payload.refresh) {
          this.payload.refresh()
        }
        this.is_sent_file = true
        this.is_loading = false
        this.removeModal(this.payload)
      }).catch(() => {
        this.is_loading = false
        this.showToast('ארעה שגיאה - אנא וודאי שגודל הקובץ לא גדול מ- 10MB')
      })
    },
    ...mapActions('toasts', ['showToast']),
    ...mapMutations('modals', ['removeModal'])
  },
  components: {
    Checkbox
  }
}
</script>
